
import React from 'react';

export const BanknotesIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    payments
  </span>
);